import { render, staticRenderFns } from "./AddOrEditSpacePopup.vue?vue&type=template&id=315ac2ac&scoped=true"
import script from "./AddOrEditSpacePopup.vue?vue&type=script&lang=ts"
export * from "./AddOrEditSpacePopup.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditSpacePopup.vue?vue&type=style&index=0&id=315ac2ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315ac2ac",
  null
  
)

export default component.exports